<template>
  <div class="fl" :class="getClass()">
    <span @click="this.handleClick" @click.middle="handleClose" class="text">{{this.navigationItem.text}}</span>
    <div v-if="this.navigationItem.isCloseable" :class="getCloseableClass()" @click="this.handleClose" />
  </div>
</template>

<script>
export default {
  name: 'SubNavigationItem',
  props: {
    navigationItem: Object
  },
  methods: {
    getClass () {
      if (this.navigationItem.isActive) { return 'sub-navigation-item active'; }
      return 'sub-navigation-item inactive';
    },
    getCloseableClass () {
      if (this.navigationItem.isActive) { return 'sub-navigation-item-close active'; }
      return 'sub-navigation-item-close inactive';
    },
    handleClick (e) {
      this.$store.dispatch(this.navigationItem.navigateAction, this.navigationItem);
    },
    handleClose () {
      this.$store.dispatch(this.navigationItem.closeAction, this.navigationItem);
    }
  }
};
</script>

<style lang="scss" scope>
@import '@/assets/stylesheets/variables.scss';

.text {
  padding: 10px 0px;
}

.sub-navigation-item-close {
  margin-top: 2px;
}

.sub-navigation-item {
  color: #8992AB;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  position: relative;
  user-select: none;
  cursor: pointer;
  padding: 0px 20px;
  height: 50px;
  transition: all 200ms cubic-bezier(0,.95,.47,.92);
  align-items: center;
  margin-right: 20px;

  &.inactive {
    background: $secondary;
    border-bottom: 0;

    .text {
      color: #71e3ff;
      font-weight: 500;
    }

    &:hover {
      background: $secondary;
      .text {
        color: white;
        font-weight: 500;
      }
      .sub-navigation-item-close {
        margin-left: 17px;
        width: 9px;
        height: 9px;
        background-color: rgba(202, 232, 240, 0.7);
        &:hover {
          background-color: $tertiary;
          transform: scale(1.2, 1.2);
        }
      }
    }
  }

  &.active {
    background-color: white;

    .text {
      color: $primary;
      font-weight: 700;
    }
  }

  .sub-navigation-item-close {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: $primary-lighten-2;
    margin-top: 2px;
    transition: all 200ms cubic-bezier(0,.95,.47,.92);

    &.active {
      margin-left: 17px;
      width: 9px;
      height: 9px;
    }

    &.inactive {
      margin-left: 0px;
      width: 0px;
      height: 0px;
    }

    &:hover {
      background-color: $error;
      transform: scale(1.2, 1.2);
      margin-left: 17px;
    }
  }
}
</style>
